// Page JobOffer

import './index.scss';

export default class PageJoboffer {
    constructor(root) {
        this.root = root;

        this.initButtons();
        this.update();
    }

    // Init

    initButtons() {
        this.siteButton = document.querySelector('.site-header [data-popup-open="app-form-popup"]');
        if (this.siteButton) { this.siteButton.addEventListener('click', this.trackFormOpen.bind(this)); }

        this.pageButton = document.querySelector('.page-joboffer-header [data-popup-open="app-form-popup"]');
        if (this.pageButton) { this.pageButton.addEventListener('click', this.trackFormOpen.bind(this)); }
    }

    // Tracking

    trackPageOpen() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Joboffer opened',
            'title': this.root.dataset.jobofferName,
            'location': this.root.dataset.jobofferLocation,
            'function': this.root.dataset.jobofferActivity,
        });

        //console.log(window.dataLayer);
    }

    trackFormOpen() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Application form opened',
            'title': this.root.dataset.jobofferName,
            'location': this.root.dataset.jobofferLocation,
            'function': this.root.dataset.jobofferActivity,
        });

        //console.log(window.dataLayer);
    }

    trackFormSend() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Application sent',
            'title': this.root.dataset.jobofferName,
            'location': this.root.dataset.jobofferLocation,
            'function': this.root.dataset.jobofferActivity,
        });

        //console.log(window.dataLayer);
    }

    // Update

    resize() { this.update(); }
    scroll() { this.update(); }

    update() {
        const rect = this.pageButton.getBoundingClientRect();
        if (rect.y < 0) {
            this.siteButton.classList.remove('button--transparent');
        } else {
            this.siteButton.classList.add('button--transparent');
        }
    }
}
